import * as React from 'react';
import Select, { ActionMeta, MultiValue } from 'react-select';

import { MultiSelectDropdownProps, SelectOption } from 'types/inputProps';

const MultiSelect = (props: MultiSelectDropdownProps): React.JSX.Element => {
  const [selectedOption, setSelectedOption] = React.useState<MultiValue<SelectOption> | null>(props.defaultValue);
  const allOption: SelectOption = props.allOption ?? { value: '*', label: 'All' };

  const handleChange = (options: MultiValue<SelectOption>): void => {
    setSelectedOption(options);
    props.onSelection(options as SelectOption[]);
  };

  const handleChangeWithAll = (selectedOptions: MultiValue<SelectOption>, event: ActionMeta<SelectOption>): void => {
    if (selectedOptions !== null && selectedOptions.length > 0) {
      if (selectedOptions[selectedOptions.length - 1].value === allOption.value) {
        setSelectedOption([allOption, ...props.options]);
        return props.onSelection([allOption, ...props.options]);
      }
      let result: SelectOption[] = [];
      if (selectedOptions.length === props.options.length) {
        if (selectedOptions.includes(allOption)) {
          result = selectedOptions.filter((option) => option.value !== allOption.value);
        } else if (event.action === 'select-option') {
          result = [allOption, ...props.options];
        }
        setSelectedOption(result);
        return props.onSelection(result);
      }
    }
    setSelectedOption(selectedOptions);
    return props.onSelection(selectedOptions as SelectOption[]);
  };

  return (
    <div className="multi-select-dropdown-wrapper">
      <Select<SelectOption, true>
        styles={props.styles}
        value={selectedOption}
        onChange={props.allowSelectAll ? handleChangeWithAll : handleChange}
        options={props.allowSelectAll ? [allOption, ...props.options] : props.options}
        placeholder={props.placeholder}
        getOptionLabel={(option: SelectOption) => option.label}
        getOptionValue={(option: SelectOption) => option.value}
        isSearchable
        isClearable
        isMulti
        closeMenuOnSelect={props.closeMenuOnSelect ?? true}
        noOptionsMessage={() => (props.hideNoOptionsMessage ? null : 'No Options')}
      />
    </div>
  );
};

export default MultiSelect;
